import { env } from 'configs/EnvironmentConfig';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { AUTH_CONSTANT } from 'constants/AuthConstant';
import { REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant';
import { TOKEN_TYPE } from 'constants/api.constant';
import appConfig from 'configs/app.config'
import { API_BASE_URL } from 'configs/app.config'
import ServiceUtils from 'utils/ServiceUtils'
import axios from 'axios'

const baseQuery = fetchBaseQuery({
  baseUrl: env.API_ENDPOINT_URL + appConfig.apiPrefix,
  prepareHeaders: async (headers, { getState }) => {
    const jwt = sessionStorage.getItem(AUTH_CONSTANT.JWT)

    if (jwt) {
      const jwtObject = JSON.parse(jwt)
      const accessToken = jwtObject.accessToken
      const rTtimeLeft = jwtObject.expireAt - Date.now();
      console.log("refreshToken 현재남은시간 =" + rTtimeLeft);

      if (jwtObject.expireAt < Date.now()) {
        console.log("refreshToken 만료됨.")
        sessionStorage.removeItem(AUTH_CONSTANT.JWT)
      } else {
        const timeLeft = jwtObject.accessExpireAt - Date.now();
        console.log("accessToken 현재남은시간 =" + timeLeft);

        if (timeLeft < 10000) {
          console.log("accessToken 만료 도래하여 refresh.")

          const { data } = await axios.post(`${API_BASE_URL}/adm/v1/auth/refresh`, { token: jwtObject.refreshToken });
          if (ServiceUtils.checkResult(data.header)) {
            console.log("accessToken refresh 성공.");
            console.log(JSON.stringify(data.jwt));
            jwtObject.accessToken = data.jwt.accessToken;
            jwtObject.accessExpireAt = data.jwt.accessExpireAt;

            sessionStorage.setItem(AUTH_CONSTANT.JWT, JSON.stringify(jwtObject));
            headers.set(REQUEST_HEADER_AUTH_KEY, `${TOKEN_TYPE}${jwtObject.accessToken}`);
          } else {
            console.log("accessToken refresh 실패.")
            sessionStorage.removeItem(AUTH_CONSTANT.JWT)
            localStorage.removeItem(AUTH_CONSTANT.JWT)
            window.location.href = '/sign-out'
          }
        } else if (accessToken) {
          headers.set(REQUEST_HEADER_AUTH_KEY, `${TOKEN_TYPE}${accessToken}`);
        }
      }
    }

    return headers;
  },
})

const baseQueryWithInterceptor = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions)
  if (result.error && result.error.status === 401) {
    // here you can deal with 401 error
  }
  if (result.error && result.error.status === 403 || result.error && result.error.originalStatus === 403) {
    window.location.href = '/sign-out'
  }
  return result
}

export const api = createApi({
  refetchOnFocus: false,
  keepUnusedDataFor: 0,
  baseQuery: baseQueryWithInterceptor,
  endpoints: () => ({}),
})

